import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useGetTasksQuery } from '../../features/task/taskApi';
import Task from './Task';

const TaskList = () => {

    const {filter, searchKeyword} = useSelector(state => state.task);
    const {data:tasks, isLoading, isError, refetch} = useGetTasksQuery();

   /*  useEffect(() => {
        refetch();
    },[filter, searchKeyword]) */

    let content;

    if(isLoading){
        content = <div className='checkbox-container'>Loading...</div>
    }

    if(!isLoading && isError){
        content = <div className='checkbox-container'>something went wrong</div>
    }

    if(!isLoading && !isError && tasks?.length === 0){
        content = <div className='checkbox-container'>No tasks available</div>
    }

    if(!isLoading && !isError && tasks?.length > 0){
        content = tasks
        .filter((task) => {
            if(searchKeyword){
             return task.taskName.toLowerCase().includes(searchKeyword.toLowerCase());
            }
            return task
        })
        .filter((task) => filter.includes(task.project.projectName))
        .map((task) => <Task key={task.id} task={task}/>)
    }

    return (
        <div className="lws-task-list">
          {content}
        </div>
    );
};

export default TaskList;